import CookiePolicy from './cookiepolicy'
import LatestPosts from './gutenberg-latestposts'
import Popup from './gutenberg-popup'
import Quicklinks from './gutenberg-quicklinks'
import Menu from './menu'
import Modal from './modal'
import ScrollToTop from './scrolltotop'
import SearchGlobal from './search-global'
import SearchBar from './searchBar'
import StickyNav from './stickynav'

const init = () => {
	window.requestAnimationFrame( () => {
		CookiePolicy()
		LatestPosts()
		Popup()
		Quicklinks()
		Menu()
		Modal()
		ScrollToTop()
		SearchGlobal()
		SearchBar()
		StickyNav()
	} )
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init, { once: true } )
} else {
	init()
}
